<script>
export default {
  name: 'ReportsTableTooltip',
  props: ['content', 'placement'],
  data() {
    return {
      placementMode: this.placement ?? 'left',
    };
  },
};
</script>

<template>
<span class="icon-container tooltip-icon-container"
  @click.stop
  v-tooltip="{
        placement: placementMode,
        content: content,
        show: false,
        delay: {show: 500, hide: 100}}">
  <i class="mdi mdi-help-circle"></i>
</span>
</template>

<style scoped lang="stylus">
.icon-container
    cursor help
    color #525F66
    font-size 18px
    margin-left 3px
</style>
